import axios from "../axios-auth";
import orginal_axios from "axios";

export const orderService = {
    getOrderList,
    printInvoiceById,
    showWindowDialog,
    saveOrder,
    getOrderDetail,
    getPendingOrderCount,
    exportOrderExcel,
    updateOrderDetail
};

function getOrderList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromOrderDate) {
        params["fromOrderDate"] = searchParams.fromOrderDate;
    }
    if (searchParams.toOrderDate) {
        params["toOrderDate"] = searchParams.toOrderDate;
    }
    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }
    if (searchParams.orderNo) {
        params["orderNo"] = searchParams.orderNo;
    }
    if (searchParams.customerName) {
        params["customerName"] = searchParams.customerName;
    }
    if (searchParams.exactCustomerName) {
        params["exactCustomerName"] = searchParams.exactCustomerName;
    }
    if (searchParams.marketerName) {
        params["marketerName"] = searchParams.marketerName;
    }
    if (searchParams.status) {
        params["orderStatus"] = searchParams.status;
    }
    if (searchParams.wholesaleFlag) {
        params["wholesaleFlag"] = searchParams.wholesaleFlag;
    }
    if (searchParams.poFlag) {
        params["poFlag"] = searchParams.poFlag;
    }
    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.updateUserId) {
        params["updateUserId"] = searchParams.updateUserId;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }

    return axios.get("/auth/orders", { params });
}

function printInvoiceById(id) {
    return orginal_axios({
        url: axios.defaults.baseURL + "/auth/print-order-invoice/" + id,
        method: "GET",
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/pdf",
            "Content-Type": "application/json"
        }
    }).then(function (response) {
        return new Blob([response.data], { type: "application/pdf" });
    });
}

function showWindowDialog(blob, fileName) {
    // IE doesn't allow using a blob object directly as link href
    // instead it is necessary to use msSaveOrOpenBlob
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob);
        return;
    }
    // For other browsers: 
    // Create a link pointing to the ObjectURL containing the blob.
    const data = window.URL.createObjectURL(blob);
    var link = document.createElement(fileName);
    link.href = data;
    link.download = fileName + ".pdf";
    window.open(link.href, fileName, "width=500,height=500");

    setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
    }, 100);
}

function saveOrder(order) {
    if (!order.id) {
        // new order
        return axios.post("/auth/order-head", order);
    } else {
        // edit
        return axios.put("/auth/order-head", order);
    }
}

function getOrderDetail(id) {
    return axios.get("/auth/order-head/" + id);
}

function getPendingOrderCount() {
    return axios.get("/auth/order-pending-count");
}

function exportOrderExcel(searchParams) {
    let params = {};

    if (searchParams.fromOrderDate) {
        params["fromOrderDate"] = searchParams.fromOrderDate;
    }
    if (searchParams.toOrderDate) {
        params["toOrderDate"] = searchParams.toOrderDate;
    }
    if (searchParams.status) {
        params["orderStatus"] = searchParams.status;
    }
    if (searchParams.customerName) {
        params["customerName"] = searchParams.customerName;
    }
    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }
    if (searchParams.orderNo) {
        params["orderNo"] = searchParams.orderNo;
    }
    if (searchParams.marketerName) {
        params["marketerName"] = searchParams.marketerName;
    }
    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.updateUserId) {
        params["updateUserId"] = searchParams.updateUserId;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/order-excel-export",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function updateOrderDetail(orderDetail) {
    return axios.put("/auth/order-detail", orderDetail)
}